export { LocaleSwitcher } from './LocaleSwitcher';
